export default "__VITE_PUBLIC_ASSET__8c6bbf49__"